<template>
		<div style="background-color:#F5F5F5;width:100%;height:100%;display:flex;flex-direction: column;align-items:center;">
			<div class="bjbottom bjtop" style="font-size:30px;">{{titles.name}}</div>
			<div v-html="titles.content" style="width:1200px;text-align:left;font-size:14px;"></div>
			<!-- <div style="display: flex;justify-content: center;align-items: center;">
				<div style="text-align: center;background-color: aqua;">
						<div class="zwk2" style="background-color:white;padding:10px 10px 0px 10px;">
						<div >
								<div style="margin-top: 10px;display: flex;">
									<img src="../assets/banner/2.png" style="width:687px;height: 262px;" />
									<div class="artitle_media">
										<video :autoplay="true" preload controls style="width: 332px;height: 262px;margin-left: 20px;">
										      <source :src="videurl" type="video/mp4" />
										 </video>
									</div>
								</div>
								<div class="bjbottom bjtop">标题名称</div>
								<div class="bjtop" style="text-align: left;line-height:30px;">探索良性前列腺增生(BPH)的有效防治
								方法,验证电针肾 俞,会阳穴治疗良性前列腺增生的有效性,
								进一步探求本法治疗BPH的作用机制,更好地指导临床,优化针灸取穴方案. 方法:①本研究共选用
								SD雄性大鼠50只,先随机取10只作为假手术组(手术但不去势),其余40只采用去势后注射丙酸睾酮法造模,
								即手术摘除双侧睾丸, 去势后再将其随机分为4组,即模型组,传统针刺组(针刺关元,中极,三阴
								交穴),西药(保列治)组,电针组(电针肾俞,会阳穴),每组10只,从去势第8 天起,每只鼠每天皮下注射丙酸睾酮
								,并同时给予相应的处理,连续四周.②检测各组大鼠前列腺湿重,指数</div>
								
							</div>
						</div>
				</div>
			</div> -->
			<!-- <div class="ljbm" @click="tap()">立即报名</div> -->
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"activity",
		components:{
		},
		data() {
			return {
				sousuok:'',
				tabIndex:7,
				tabIndexs:0,
				videurl:'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4',
				url:'https://www.baidu.com/',
				id:'',
				titles:'',
			}
		},
		created() {
			this.id=this.$route.query.data
			console.log(this.id);
			this.title()
		},
		methods: {
		tap:function(){
			this.$store.commit("collgepx",0)
			this.$store.commit("business",1)
			this.$router.push({name:'sign'});
			this.$store.commit("navbgshow",9)
		},
		title:function(){
			//获取园区列表接口
			axios({
			    url: `${base.url}/api/user/park`,
			    method: 'post',
			    data:{id:this.id}
			}).then((res) => {
				if(res.code==1){
					console.log(res,111111);
					this.titles=res.data
				}
			        })
		}
		},
	}
</script>

<style lang="scss" scoped>
	.artitle_media{
	    text-align: center;
	}
	.artitle_media video{
	    object-fit:fill;
	    width:100%;
	    height:100%;
	    margin-left: auto;
	    margin-right: auto;
		outline:none
	}
	.zwk{
		margin:0px 10px 0px 0px;
		width: 348px;
		height:695px;
		background-color:#ffffff;
	}
	.zwk2{
		width: 1150px;
		height:695px;
		background-color:#ffffff;
	}
	.ljbm{
		background-color:#20919D;
		width: 340px;
		height: 38px;
		color: white;
		line-height:38px;
		margin-top:50px;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.font{
		font-size:14px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 20px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:20px;
	}
	.zxls{
		text-align: left;
		color:#181818;
		font-size:16px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
</style>
